

























































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { TechnicalReportData } from "@/entities";
import HeaderInfo from "../../ExpansionPanel/TechExpansionPanel.vue";
import NavButtons from "@/components/common/Buttons/NavButtons.vue";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";

const namespace: string = "technicalReport";

@Component({
  components: {
    HeaderInfo,
    NavButtons,
    VJsonschemaForm
  }
})
export default class InterimCommunications extends Vue {
  @Prop() readOnly: boolean;
  @Prop() docTags: any;
  @Prop() model: any;
  @Prop() schema: any;
  @Prop() formOptions: any;
  @State(namespace) technicalReport!: TechnicalReportData;
  @Getter("grantInfo", { namespace }) grantInfo: any;
  @Getter("selectedReport", { namespace }) report: any;
  @Prop() technicalReportSections: any;
  @Prop() isDirty: any;
  @Prop() workFlowItems: any;
  @Prop() preValidation: any;
  @Prop() entity: any;
  @Prop() enableButton: any;

  options: any = {};
  schemaformKey: number = 0;

  /** input event */
  showInput(e) {
    this.$emit("input", true);
  }

  /** error event */
  showError(err) {
    window.alert(err); 
  }

  /** change event */
  showChange(e) {
    this.$emit("input", true);
  }

  getFeedbackHeader(rowKey) {
    if (this.formOptions && this.formOptions.feedbacks) {
      return this.formOptions.feedbacks.find(x => x.RowKey === rowKey);
    } else {
        return null;
    }
  }

  get dataModel() {
    if(this.model[0] && !this.model[0].interimCommunications)
      this.model[0].interimCommunications = {};
	return this.model[0].interimCommunications;
  }

  @Watch("dataModel")
  onDataChanged(value: any, oldValue: any) {
    this.schemaformKey += 1;
  }
}
